<template>
    <h5-dialog
        closeable
        title="微信公众号支付"
        style="z-index:1006;"
        @on-close="$emit('on-close')"
    >
        <div class="wxpay-title">前往微信公众号：3698K</div>
        <div class="to-center">
            <van-button
                round
                size="small"
                @click="onCopy"
                color="#4187f2"
            >
                复制公众号
            </van-button>
        </div>
    </h5-dialog>
</template>

<script>
import { Button } from 'vant'
import H5Dialog from '@/components/H5Dialog.vue'
import { queryWxPayOrder } from '@/service'
import { getLocalAccountData, getLocalAppConfig } from '@/utils/storage'
import { getParamsByUrl } from '@/utils/url'
import browser from '@/utils/browser'

export default {
    components: {
        H5Dialog,
        VanButton: Button,
    },
    props: ['info'],
    data() {
        return {}
    },
    methods: {
        createWxPayOrder() {
            const {
                appConfig = getLocalAppConfig(),
                accountData = getLocalAccountData(),
            } = this.$store.state

            const params = {
                muid: appConfig.muid || getParamsByUrl('muid', this.info.value),
                game_id: appConfig.game_id || getParamsByUrl('game_id', this.info.value),
                platform: appConfig.platform,
                username: accountData.username || getParamsByUrl('username', this.info.value),
                user_token: accountData.user_token,
                reg_time: accountData.reg_time,
                debug: 'development',
                is_pc: browser.isPC  ? 1 : 0,
                // token_sign: 'JhGame666nbl2V|gfZp{8`;jzR~6Y1_mOtErFer',
                // 以下
                referer: accountData.username || getParamsByUrl('username', this.info.value),
                pay_code: '510',
                pay_type: 'inner_wx'
            };

            ([
                'server_id',
                'server_name',
                'order_money',
                'pay_money',
                'goods_name',
                'goods_id',
                'role',
                'role_id',
                'data',
                'ext',
                'pay_sign',
                'timestamp',
            ]).forEach(key => {
                params[key] = getParamsByUrl(key, this.info.value)
            })

            queryWxPayOrder(params).then(res => {
                if (res?.code === 0) {
                    console.log('下单成功')
                }
            })
        },
        onCopy() {
            this.$copyText('3698k').then(()=> {
                this.$toast('复制成功')
            }, ()=> {
                this.$toast('复制失败')
            })
        }
    },
    mounted() {
        this.createWxPayOrder()
    }
}
</script>

<style scoped>
.wxpay-title {
    text-align: center;
    font-size: 20px;
    color: #999;
    font-weight: bold;
    margin: 30px 0 10px 0;
}
</style>